// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noResultCard {
  margin: 22px 0 10px;
  padding: 22px 18px;
  border-radius: 16px;
  background: var(--white-principale);
  border: 1px solid rgba(17, 24, 39, 0.08);
  box-shadow: 0 10px 28px rgba(17, 24, 39, 0.08);
  text-align: center;
}

.noResultIcon {
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.14), rgba(59, 130, 246, 0.10));
  color: var(--couleur-principale);
}

.noResultIcon svg {
  width: 28px;
  height: 28px;
}

.noResultTitle {
  margin: 6px 0 6px;
  font-size: 16px;
  font-weight: 900;
  color: #111827;
}

.noResultText {
  margin: 0 auto 14px;
  max-width: 520px;
  font-size: 13px;
  line-height: 1.5;
  color: rgba(75, 85, 99, 0.95);
}

.noResultActions {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.noResultBtn {
  border: 0;
  border-radius: 999px;
  padding: 9px 14px;
  font-weight: 900;
  font-size: 12px;
  cursor: pointer;
  transition: transform .12s ease, box-shadow .12s ease, background .12s ease;
}

.noResultBtn:active {
  transform: translateY(1px);
}

.noResultBtnPrimary {
  color: var(--white-principale);
  background: linear-gradient(135deg, var(--couleur-principale), var(--couleur-secondaire));
  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.22);
}

.noResultBtnPrimary:hover {
  box-shadow: 0 12px 26px rgba(37, 99, 235, 0.28);
}

.noResultBtnGhost {
  color: #111827;
  background: rgba(17, 24, 39, 0.06);
}

.noResultBtnGhost:hover {
  background: rgba(17, 24, 39, 0.10);
}

/* Apparition douce de la carte */
.noResultCard {
  animation: noResultFadeIn 0.35s ease;
}

@keyframes noResultFadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Icône : pulsation douce pour signifier le chargement */
.noResultIcon {
  animation: noResultPulse 1.6s ease-in-out infinite;
}

@keyframes noResultPulse {

  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.25);
  }

  50% {
    transform: scale(1.06);
    box-shadow: 0 0 0 8px rgba(99, 102, 241, 0);
  }
}

/* Texte de chargement : léger effet de respiration */
.noResultTitle {
  animation: noResultTextFade 1.6s ease-in-out infinite;
}

@keyframes noResultTextFade {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }
}

/* Respecte les préférences d'accessibilité */
@media (prefers-reduced-motion: reduce) {

  .noResultCard,
  .noResultIcon,
  .noResultTitle {
    animation: none;
  }
}

@media (max-width: 576px) {
  .noResultCard {
    padding: 18px 14px;
    border-radius: 14px;
  }

  .noResultTitle {
    font-size: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/article/Articles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,wCAAwC;EACxC,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uFAAuF;EACvF,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,yFAAyF;EACzF,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,iCAAiC;AACjC;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,yDAAyD;AACzD;EACE,kDAAkD;AACpD;;AAEA;;EAEE;;IAEE,mBAAmB;IACnB,4CAA4C;EAC9C;;EAEA;IACE,sBAAsB;IACtB,2CAA2C;EAC7C;AACF;;AAEA,qDAAqD;AACrD;EACE,qDAAqD;AACvD;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,6CAA6C;AAC7C;;EAEE;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".noResultCard {\n  margin: 22px 0 10px;\n  padding: 22px 18px;\n  border-radius: 16px;\n  background: var(--white-principale);\n  border: 1px solid rgba(17, 24, 39, 0.08);\n  box-shadow: 0 10px 28px rgba(17, 24, 39, 0.08);\n  text-align: center;\n}\n\n.noResultIcon {\n  width: 56px;\n  height: 56px;\n  margin: 0 auto 12px;\n  border-radius: 14px;\n  display: grid;\n  place-items: center;\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.14), rgba(59, 130, 246, 0.10));\n  color: var(--couleur-principale);\n}\n\n.noResultIcon svg {\n  width: 28px;\n  height: 28px;\n}\n\n.noResultTitle {\n  margin: 6px 0 6px;\n  font-size: 16px;\n  font-weight: 900;\n  color: #111827;\n}\n\n.noResultText {\n  margin: 0 auto 14px;\n  max-width: 520px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: rgba(75, 85, 99, 0.95);\n}\n\n.noResultActions {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.noResultBtn {\n  border: 0;\n  border-radius: 999px;\n  padding: 9px 14px;\n  font-weight: 900;\n  font-size: 12px;\n  cursor: pointer;\n  transition: transform .12s ease, box-shadow .12s ease, background .12s ease;\n}\n\n.noResultBtn:active {\n  transform: translateY(1px);\n}\n\n.noResultBtnPrimary {\n  color: var(--white-principale);\n  background: linear-gradient(135deg, var(--couleur-principale), var(--couleur-secondaire));\n  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.22);\n}\n\n.noResultBtnPrimary:hover {\n  box-shadow: 0 12px 26px rgba(37, 99, 235, 0.28);\n}\n\n.noResultBtnGhost {\n  color: #111827;\n  background: rgba(17, 24, 39, 0.06);\n}\n\n.noResultBtnGhost:hover {\n  background: rgba(17, 24, 39, 0.10);\n}\n\n/* Apparition douce de la carte */\n.noResultCard {\n  animation: noResultFadeIn 0.35s ease;\n}\n\n@keyframes noResultFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Icône : pulsation douce pour signifier le chargement */\n.noResultIcon {\n  animation: noResultPulse 1.6s ease-in-out infinite;\n}\n\n@keyframes noResultPulse {\n\n  0%,\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.25);\n  }\n\n  50% {\n    transform: scale(1.06);\n    box-shadow: 0 0 0 8px rgba(99, 102, 241, 0);\n  }\n}\n\n/* Texte de chargement : léger effet de respiration */\n.noResultTitle {\n  animation: noResultTextFade 1.6s ease-in-out infinite;\n}\n\n@keyframes noResultTextFade {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.6;\n  }\n}\n\n/* Respecte les préférences d'accessibilité */\n@media (prefers-reduced-motion: reduce) {\n\n  .noResultCard,\n  .noResultIcon,\n  .noResultTitle {\n    animation: none;\n  }\n}\n\n@media (max-width: 576px) {\n  .noResultCard {\n    padding: 18px 14px;\n    border-radius: 14px;\n  }\n\n  .noResultTitle {\n    font-size: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
